import React, { useEffect, useState } from 'react'
import HeaderSection from '../../../common/headerSection'
import PageHeader from '../../../common/pageHeader'
import CustomToast from '../../../../widgets/toaster'
import { useTranslation } from 'react-i18next'
import Pagination from '../../../../widgets/pagination'
import { DEFAULT_PAGE_SIZE } from '../../../../constants/constants'
import CustomTable from '../../../../widgets/table'
import { scheduleService } from '../../../../service/scheduleService'
import moment from 'moment'
import { columns } from './partials/columns'
import { areaService } from '../../../../service/areaServices'
import { Button, Modal } from 'react-bootstrap'
import baseUrl from '../../../../service'
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";
import { printWithZebraPrinter } from '../../../../utils/zebraPrinter'


declare global {
    interface Window {
      BrowserPrint: any;
    }
  }

const PersonnelMonitoringQr = () => {

    const { t } = useTranslation();
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0]; // YYYY-MM-DD

    const date7DaysAgo = new Date();
    date7DaysAgo.setDate(date7DaysAgo.getDate() - 7);
    const formattedDate7DaysAgo = date7DaysAgo.toISOString().split("T")[0];

    const formattedTime = currentDate.toTimeString().split(' ')[0]; // HH:MM:SS
    const dateTime = `${formattedDate7DaysAgo} 00:00:00`;

    // end date should be 1 week ahead from currentDate
    const endDate = new Date(currentDate);
    const formattedEndDate = endDate.toISOString().split('T')[0]; // YYYY-MM-DD
    const formattedEndTime = currentDate.toTimeString().split(' ')[0]; // HH:MM:SS
    const endDateTime = `${formattedEndDate} 23:59:59`;

    //toaster section
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("");
    // table pagination
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [useEffectRequired, setUseEffectRequired] = useState(false);
    const [actionClearAll, setActionClearAll] = useState(false);
    const [assignedTaskList, setAssignedTaskList] = useState([]);
    const [selectedPlatesForQr, setselectedPlatesForQr] = useState([]);

    const [areaData, setAreaData] = useState([]);
    const [usersList, setUsersList] = useState<Array<any>>([]);
    const [activityTypeId, setActivityTypeId] = useState("");
    const [processId, setProcessId] = useState("");
    const [proScheduleId, setProScheduleId] = useState("")
    const [assignee, setAssignee] = useState("");
    const [location, setLocation] = useState("");
    const [areaId, setAreaId] = useState("");
    const [status, setStatus] = useState("active,inactive");
    const [fromDate, setFromDate] = useState(dateTime);
    const [toDate, setToDate] = useState(endDateTime);
    const [keyWord, setkeyWord] = useState("");
    const [sort, setSort] = useState("id");
    const [order, setOrder] = useState("desc");
    const [qrModalShow, setQrModalShow] = useState(false);
    const [selectedSlnoLen, setSelectedSlnoLen] = useState(0);
    const [cellWidth, setCellWidth] = useState(1); 
    const [zplList, setzplList] = useState<Array<any>>([]);

    const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
const [productList, setProductList] = useState<Array<any>>([]);
const [scheduleProductId, setScheduleProductId] = useState("");
const [productId, setProductId] = useState("");
 const sortRemoveList=["production_schedule_name","activity_type","product_name","qr_generated_date"]   
    // get table data
    const listAssignedTask = async () => {
        try {
            const response = await scheduleService.getPersonnelMonitoringQRDetails(
                page,
                pageSize,
                sort,
                order,
                scheduleProductId,
                assignee,
                fromDate,
                toDate,
                areaId,
                productId,
            );
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        setTotalPages(response?.totalPages);
                        setTotalElements(response?.totalElements);
                        let rowData: any = response.data.map(
                            (element: any, index: number) => {
                                return {
                                    slno: index + 1,
                                    id: element.id,
                                    production_schedule_name:element.production_schedule_name,
                                    product_name:element.product_name,
                                    plate_serial_no: element.serial_number,
                                    qr_name: element?.qr_name,
                                    qr_generated_date: element?.qr_generated_datetime,
                                    assignee: element?.assigned_operator_name,
                                    finger_dabbed_user: element?.fingerdabbing_operator_name,
                                    activity_type: element?.assigned_activity_name,
                                    area_name: element?.area_name,
                                    finger_dab_option_name: element?.finger_dab_option_name,
                                    prn_value: element.prn_value
                                };
                            }
                        );
                        setAssignedTaskList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setAssignedTaskList([]);
                setTotalPages(0);
                setTotalElements(0);
            }
        } catch (error) {
            console.error("user response", error);
        }
    };


    const handleSort = (key: string, value: boolean) => {
    setSort(key);
    if (value) {
      setOrder("asc");
    } else {
      setOrder("desc");
    }
    setUseEffectRequired(true);
  };

    // Get production schedules for filter dropdown
    const getProductionSchedules = async () => {
        try {
            const response = await scheduleService.getProductionSchedules();
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map(
                            (element: any, index: number) => {
                                return {
                                    slno: index + 1,
                                    id: element.id,
                                    production_schedule_name: element?.production_schedule_name,
                                    activity_type_id: element.activity_type_id,
                                };
                            }
                        );
                        setProdScheduleList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setProdScheduleList([]);
            }
        } catch (error) {
            console.error("user response", error);
        }
    };

    // Get product list for filter dropdown
    const getProductList = async () => {
        try {
            const response = await scheduleService.getProductList();
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map(
                            (element: any, index: number) => {
                                return {
                                    id: element.id,
                                    name: element.name,
                                };
                            }
                        );
                        setProductList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setProductList([]);
            }
        } catch (error) {
            console.error("user response", error);
        }
    };

    //handle table pagination
    const handlePageChange = (newPage: any, pageSize?: number) => {
        setPage(newPage);
        if (pageSize) {
            setPageSize(pageSize);
        }
        setActionClearAll(true)
        setUseEffectRequired(true);
    };

    // get area List
    const getAreaList = async () => {
        try {
            const response = await areaService.getAreaList(0, 0, sort, order, "", "8,12,9,6,17");
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map((element: any, index: number) => {

                            const role = element.role_master_id === "1" ?
                                "Admin" : element.role_master_id === "2" ?
                                    "Operator" : element.role_master_id === "3" ?
                                        "Lab Operator" : null
                            const statusNumber = parseInt(element.type, 10);
                            const area_type = areaService.getLocationStatus(statusNumber);

                            return {
                                slno: index + 1,
                                id: element.id,
                                area_code: element.area_code,
                                name: element.name,
                                area_type: element.location_type_name,
                                status: element.status,
                                qr_image_path: element.qr_image_path,
                            };
                        });
                        setAreaData(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setAreaData([]);
            }
        } catch (error) {
            console.error('user response', error);
        }
    };

    // getMasterUserList()
    const getMasterUserList = async () => {
        try {
            // const response = await scheduleService.getMasterUserList();
            const response = await scheduleService.getMasterUserListWithUserCode();
            if (response.status && response.statusCode === 200) {
                try {
                    if (Array.isArray(response.data) && response.data?.length > 0) {
                        let rowData: any = response.data.map(
                            (element: any, index: number) => {
                                return {
                                    slno: index + 1,
                                    id: element.id,
                                    name: element.user_fullname_with_id
                                    // name: (
                                    //     (element?.first_name).trim() +
                                    //     " " +
                                    //     (element?.last_name).trim()
                                    // ).trim(),
                                };
                            }
                        );
                        setUsersList(rowData);
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                setUsersList([]);
            }
        } catch (error) {
            console.error("user response", error);
        }
    };

    // handle close modal
    const handleCloseQrModal = () => {
        setQrModalShow(false);
        setCellWidth(1);
    }

    const handleDowloadQrBtnClick = (slno: string[]) => {
        setQrModalShow(true)
        const filteredPlateDetails = assignedTaskList.filter((item: any) => slno.includes(item.slno));
        const prnList = filteredPlateDetails.map((item: any) => item.prn_value);
        setselectedPlatesForQr(filteredPlateDetails)
        setzplList(prnList)


    }

    const handleDownloadBtn = () => {
    const content: any = document.getElementById("innerDiv");
    const pri: any = window.open("", "", "height=800,width=1000");

    pri.document.open();
    pri.document.write(`
        <html>
            <head>
                <title>Print QR Codes</title>
                    <style>
                @page { size: A4 portrait; margin: 0; }
                body, html {
                    margin: 0;
                    padding: 0;
                    width: 210mm;
                    height: 297mm;
                }
                .page {
                    page-break-after: always;
                    width: 210mm;
                    height: 297mm;
                }
            </style>
            </head>
            <body>${content.innerHTML}</body>
        </html>
    `);
    pri.document.close();

    pri.onload = () => {
        const images = pri.document.images;
        let loadedImages = 0;

        if (images.length === 0) {
            startPrint();
            return;
        }

        for (let i = 0; i < images.length; i++) {
            images[i].onload = images[i].onerror = () => {
                loadedImages++;
                if (loadedImages === images.length) {
                    startPrint();
                }
            };
        }
    };

    function startPrint() {
        pri.focus();
        pri.print();
        pri.onafterprint = () => {
            pri.close();
            setQrModalShow(false);
            setActionClearAll(true);
            setCellWidth(1);
        };
    }
};

    //table filter section
    const handleFilter = (key: string, value: any) => {
        if (key === "search") {
            setkeyWord(value);
        } else if (key === "activityType") {
            setActivityTypeId(value)
        } else if (key === "productionSchedule") {
            setScheduleProductId(value) 
        } else if (key === "productName") {
            setProductId(value)
        }else if (key === "location") {
            setLocation(value)
        } else if (key === "area") {
            setAreaId(value)
        } else if (key === "assignee") {
            setAssignee(value)
        } else if (key === "FromDate") {
            const formattedDate = value ? moment(value).format("YYYY-MM-DD 00:00:00") : "";
            setFromDate(formattedDate)
            setToDate("")
        } else if (key === "ToDate") {
            const formattedDate = value ? moment(value).format("YYYY-MM-DD 23:59:59") : "";
            setToDate(formattedDate)
        }

        setUseEffectRequired(true);
    };

    const createGrid = () => {
        return (
          <div>
            {selectedPlatesForQr.map((cellIndex: any, index: number) => (
              <div
                key={index}
                className="page"
                style={{
                  width: "210mm",
                  height: "297mm",
                  pageBreakAfter: "always",
                  padding: "10mm",
                  boxSizing: "border-box",
                  display: "grid",
                  gridTemplateColumns: "auto 1fr auto",
                  gridTemplateRows: "auto 1fr auto",
                  alignItems: "center",
                  justifyItems: "center",
                  marginTop: "10mm"
                }}
              >
                {/* Top Text */}
                <div
                  style={{
                    gridColumn: "1 / 4",
                    fontSize: "15mm",
                    textAlign: "center",
                    marginBottom: "2mm", // tighter spacing
                    marginTop: "10mm"
                  }}
                >
                  <p style={{ margin: "1mm 0" }}>{cellIndex?.activity_type}</p>
                </div>
      
                {/* Left Text (Vertical) */}
                <div
                  style={{
                    gridRow: "2",
                    writingMode: "vertical-rl",
                    transform: "rotate(180deg)", // make it bottom to top
                    fontSize: "15mm",
                    textAlign: "center",
                  }}
                >
                  <p style={{ margin: "2mm 0" }}>{cellIndex?.area_name}</p>
                  <p style={{ margin: "2mm 0" }}>{cellIndex?.assignee}</p>
                </div>
      
                {/* QR Image in the center */}
                <img
                  src={`${baseUrl}/uploads/qr/plates/${cellIndex.qr_name}`}
                  alt={`QR ${cellIndex.qr_name}`}
                  style={{
                    gridRow: "2",
                    gridColumn: "2",
                    width: "220mm",
                    height: "220mm",
                    objectFit: "contain",
                  }}
                />
      
                {/* Right Text (Vertical) */}
                <div
                  style={{
                    gridRow: "2",
                    writingMode: "vertical-rl",
                    fontSize: "15mm",
                    textAlign: "center",
                  }}
                >
                  <p style={{ margin: "2mm 0" }}>{cellIndex?.plate_serial_no}</p>
                  <p style={{ margin: "2mm 0" }}>{cellIndex?.finger_dabbed_user}</p>
                </div>
      
                {/* Bottom Text */}
                <div
                  style={{
                    gridColumn: "1 / 4",
                    fontSize: "15mm",
                    textAlign: "center",
                    marginTop: "2mm", // tighter spacing
                  }}
                >
                  <p style={{ margin: "1mm 0" }}>{cellIndex?.finger_dab_option_name}</p>
                  <p style={{ margin: "1mm 0" }}>
                    {cellIndex?.qr_generated_date}
                  </p>
                </div>
              </div>
            ))}
          </div>
        );
      };

    useEffect(() => {
        listAssignedTask();
        getAreaList();
        getMasterUserList();
        getProductionSchedules(); 
        getProductList();

        setActionClearAll(false)
        setUseEffectRequired(false)

    }, [useEffectRequired])

  return (
    <div>
        <HeaderSection />
        <PageHeader pageHeader={t("personnelMonitoringQr.personnelMonitoringQr")} />
        <CustomToast
            show={showToast}
            onClose={() => setShowToast(false)}
            delay={5000}
            message={toastMessage}
            toastType={toastType}
        />

        <div className="me-3" style={{ marginTop: "10px" }}>
            <div className=" mx-3 pe-2" style={{ height: "45vh" }}>
                <CustomTable
                    tableHead={t("personnelMonitoringQr.personnelMonitoringQr")}
                    data={assignedTaskList}
                    columns={columns}
                    // isEditable={permission?.includes("edit_operator_schedule")}
                    isEditable={false}
                    totalElements={totalElements}
                    isActionVisible={true}
                    isViewVisible={false}
                    // onViewClick={handleViewClick}
                    isSeachable={false}
                    // addButton={true}
                    // addButtonText={t("generatePlateQr.generatePlateQr")}
                    // onAddClick={handleGeneratePlateQR}
                    onFilterClick={handleFilter}
                    // onSortClick={handleSort}
                    // isToggleStatus={false}
                    // onStatusChange={handleStatusChange}
                    isQrDownloadable={false}
                    // onEditClick={handleEditClick}
                    showQrGenerateButton={false}
                    // showBlueBtn={true}
                    // blueBtnText={t("generatePlateQr.downloadQr")}
                    // onBlueBtnClick={handleDownloadQR}
                    showToDateFilter={true}
                    showFromDateFilter={true}
                    dateType='date'
                    actionCheckOrangeButton={true}
                    actionCheckOrangeBtnText={t("personnelMonitoringQr.downloadQr")}
                    onActionCheckOrangeButtonClick={handleDowloadQrBtnClick}
                    showFullFilters={true}
                    clearAll={actionClearAll}
                    areaDropList={areaData}
                    assignee={usersList}
                    prodScheduleList={prodScheduleList} 
                    productList={productList}
                    removeSortList={sortRemoveList}
                    onSortClick={handleSort}
                />
            </div>
            <div>
                <Pagination
                    page={page}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                />
            </div>
        </div>

        {/*modal for download QR*/}
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={qrModalShow}
        >
            <Modal.Header closeButton onClick={() => handleCloseQrModal()}>
                <Modal.Title id="contained-modal-title-vcenter">
                    {t("buttons.download_qr")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Selected {selectedPlatesForQr?.length} plate(s) for download QR</p>
                <div className="selectWrap">
                    {/* <div className="form-group my-1">
                        <label>{t("areaManagement.cell_width")}</label>
                        <br />
                        <input
                            type="number"
                            id="cellWidth"
                            value={cellWidth}
                            min="1"
                            onChange={(e) => {
                                const value = parseInt(e.target.value);
                                if (value > 0) {
                                    setCellWidth(value); // Update state only if value is greater than zero
                                }
                            }}
                        />
                    </div> */}
                </div>
                <div
                    id="innerDiv"
                    hidden
                    style={{
                        border: "1px solid black",
                        padding: "5px",
                        margin: "5px",
                        overflow: "scroll",
                        height: "80vh",
                    }}
                >
                    {createGrid()}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className='squareOrangeBtn3' onClick={() => handleDownloadBtn()}>
                    {t("buttons.download")}
                </Button>
                <Button className='modalCancelBtn' onClick={() => printWithZebraPrinter(zplList)}>
                    {t('buttons.print')}
                </Button>
            </Modal.Footer>
        </Modal>

    </div>
  )
}

export default PersonnelMonitoringQr